
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/app-reviews",
      function () {
        return require("private-next-pages/reports/app-reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/app-reviews"])
      });
    }
  